import { render, staticRenderFns } from "./ReplicarConfiguracao.vue?vue&type=template&id=e80dccba&scoped=true"
import script from "./ReplicarConfiguracao.vue?vue&type=script&lang=js"
export * from "./ReplicarConfiguracao.vue?vue&type=script&lang=js"
import style0 from "./ReplicarConfiguracao.vue?vue&type=style&index=0&id=e80dccba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80dccba",
  null
  
)

export default component.exports